
import React from "react";
import { Link } from "react-router-dom";
import logoImage from "@/assets/logo.png";

const Logo: React.FC = () => {
  return (
    <Link to="/" className="flex items-center space-x-2">
      <img
        src={logoImage}
        alt="Elf Letter Bot Logo"
        title="Elf Letter Bot Logo"
        width="40"
        height="40"
        className="h-10 w-auto"
        onError={(e) => {
          console.error("Logo failed to load, src:", logoImage);
          // Fallback to a simple text logo if image fails
          (e.target as HTMLImageElement).style.display = 'none';
        }}
      />
      <span className="text-foreground font-display font-bold text-xl">Elf Letter Bot</span>
    </Link>
  );
};

export default Logo;
